import React from 'react';
import { NotificationHeaderProps } from '@components/NavBar/NotificationHeader/notificationHeader.types';

export const NotificationHeader = ({
  handlePress,
}: NotificationHeaderProps): React.ReactElement => {
  void handlePress;
  return <></>;
};
